module.exports = __webpack_public_path__ + "static/img/6.01c2efe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/6.png
// module id = ujYi
// module chunks = 0